export default function Layout({ preview, children }) {
  return (
    <>
      {preview && (
        <div className="relative z-10 py-2 text-sm text-center text-white bg-utility-red">
          This is page is a preview. Some of these posts are drafts.{' '}
          <a href="/api/exit-preview" className="font-bold underline">
            Click here
          </a>{' '}
          to exit preview mode.
        </div>
      )}
      {children}
    </>
  );
}
